import { MAX_UPLOAD_FILE_SIZE, formatFileSize } from '@loader/shared-types';

// Version Guidelines Component
export function VersionGuidelines() {
  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex h-32 items-center justify-center">
          <div className="text-center">
            <h5 className="text-sm font-medium">Supported Formats</h5>
            <div className="text-muted-foreground mt-2 space-y-1 text-xs">
              <div>CSV files (.csv)</div>
              <div>JSON files (.json)</div>
              <div>Excel files (.xlsx)</div>
              <div>Parquet files (.parquet)</div>
            </div>
          </div>
        </div>
        <div className="flex h-32 items-center justify-center">
          <div className="text-center">
            <h5 className="text-sm font-medium">File Requirements</h5>
            <div className="text-muted-foreground mt-2 space-y-1 text-xs">
              <div>Maximum file size: {formatFileSize(MAX_UPLOAD_FILE_SIZE)}</div>
              <div>UTF-8 encoding recommended</div>
              <div>First row should contain headers</div>
              <div>Consistent data types per column</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
